export const ORG_LIST_SLUG = 'superadmin-organizacoes';

const ORG_DETAIL_RE = /^\/?superadmin-organizacoes\/([0-9a-f-]{36})\/?$/i;

export function parseOrgIdFromPathname(pathname: string): string | null {
    const clean = pathname.replace(/\/$/, '');
    const m = clean.match(ORG_DETAIL_RE);
    return m?.[1] ?? null;
}

export function buildOrgDetailPath(orgId: string): string {
    return `/superadmin-organizacoes/${orgId}`;
}
